import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import store from '@/store/store';
import { getProfileId } from '@/utils/profile';
import { configRoute } from './mainRoute/config.route';
import { myDocumentsRoute } from './mainRoute/myDocuments.route';
import { myProfileRoute } from './mainRoute/myProfile.route';
import { procedureRoute } from './mainRoute/procedure.route';
import { systemMessageContainerRoute } from './mainRoute/systemMessage.route';

export const mainRoute: RouteConfig = {
  path: '/',
  component: () => import(/* webpackChunkName: "AppLayout" */ '@/layouts/AppLayout.vue'),
  meta: {
    authorized: true,
    menuList: true
  },
  children: [myProfileRoute, myDocumentsRoute, procedureRoute, configRoute, systemMessageContainerRoute],
  beforeEnter: (to, from, next) => {
    const messagesPermission = 'MESSAGE.LIST:profile:' + getProfileId();
    store
      .dispatch('auth/loadData')
      .then(() =>
        Promise.all([
          store
            .dispatch('setting/findPublic', { code: PublicSettings.SIDE_MENU })
            .then(() => store.dispatch('menu/getMenu')),
          store.dispatch('auth/checkPermissions', messagesPermission).then(permissions => {
            if (permissions[messagesPermission]) {
              return store.dispatch('systemMessage/unreadList', false);
            }
          })
        ])
      )
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.AUTH_CANNOT_LOAD_DATA }));
  },
  redirect: { name: 'myProfile' }
};
